import { render, staticRenderFns } from "./tabson3.vue?vue&type=template&id=f1bc3856&"
import script from "./tabson3.vue?vue&type=script&lang=js&"
export * from "./tabson3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports